class ImageWithText extends HTMLElement {
  constructor() {
    super();

    this.readMore = this.querySelector(".image-with-text__read-more-link");
    this.text = this.querySelector(".image-with-text__content");
    this.img = this.querySelector("img.acf-image");
    if (this.readMore && this.text) {
      // check if the text is too long
      this.assignedHeight = 280;
      if (window.innerWidth > 768) {
        this.assignedHeight = this.img ? (this.img.clientHeight * 7) / 10 : 280;
      }
      this.style.setProperty(
        "--max-content-height",
        `${this.assignedHeight}px`
      );
      if (this.text.clientHeight > this.assignedHeight) {
        this.readMore.classList.remove("hidden");
        this.text.classList.add("truncate-text");
        this.readMore.addEventListener("click", () => {
          this.text.classList.toggle("truncate-text");
          this.readMore.textContent = this.text.classList.contains(
            "truncate-text"
          )
            ? "Läs mer >"
            : "Visa mindre <";
        });
      }
    }
  }
}

customElements.define("image-with-text", ImageWithText);

class SeriesTestimonial extends HTMLElement {
  constructor() {
    super();
    this.randomNumber = Math.floor(Math.random() * 100);
    this.slider = this.querySelector(".card-container");
    this._initSlider();
  }
  _initSlider() {
    // alert("here and well");
    this.slider.classList.add(`swiper-${this.randomNumber}`);
    const arrowNext = this.querySelector(".swiper-button-next");
    const arrowPrev = this.querySelector(".swiper-button-prev");
    arrowNext.classList.add(`swiper-button-next-${this.randomNumber}`);
    arrowPrev.classList.add(`swiper-button-prev-${this.randomNumber}`);
    this.swiper = new Swiper(`.swiper-${this.randomNumber}`, {
      slidesPerView: 1,
      navigation: {
        nextEl: `.swiper-button-next-${this.randomNumber}`,
        prevEl: `.swiper-button-prev-${this.randomNumber}`,
      },
    });
  }
}

customElements.define("series-testimonial", SeriesTestimonial);

class FlipsnackBox extends HTMLElement {
  constructor() {
    super();

    this._init();
  }
  _init() {
    this._initOpeners();
    this._initClosers();
  }
  open() {
    this.querySelector(".flipsnack-box__content").classList.remove("hidden");
  }
  close() {
    this.querySelector(".flipsnack-box__content").classList.add("hidden");
  }
  _initOpeners() {
    this.querySelectorAll(".flipsnack-box__button-box").forEach((el) => {
      el.addEventListener("click", () => {
        this.open();
      });
    });
  }

  _initClosers() {
    this.querySelectorAll(".book__close").forEach((el) => {
      el.addEventListener("click", () => {
        this.close();
      });
    });
  }
}
customElements.define("flipsnack-box", FlipsnackBox);

class MegaMenu extends HTMLElement {
  constructor() {
    super();

    this.filters = this.querySelectorAll(".mega-menu__filters input");

    this._combineLinks();
    this.addLinksToMenuItems();
    if (this.dataset.order) {
      this.reodred();
    }
    this.navigationData = JSON.parse(
      this.querySelector(".script-json-content").textContent
    );

    console.log(this.navigationData);

    this.navItems = this.querySelectorAll("[data-filters]");

    this.addEventListener("filter::selected", () => {
      this.reodred();

      this.swapUrls();
    });

    this.initFiltersLogic();
  }

  initFiltersLogic() {
    this.filters.forEach((filter) => {
      filter.addEventListener("change", () => {
        if (filter.checked) {
          this.filters.forEach((oldFilter) => {
            if (oldFilter !== filter && oldFilter.checked == true) {
              oldFilter.checked = false;
              oldFilter.dispatchEvent(new Event("change", { bubbles: true }));
            }
          });
        }
        this.navItems.forEach((item) => {
          if (filter.checked && item.dataset.filters.includes(filter.value)) {
            item.classList.remove("hidden");
            localStorage.setItem("selected-nav-filter", filter.value);
          } else if (filter.checked) {
            item.classList.add("hidden");
            localStorage.setItem("selected-nav-filter", filter.value);
          } else {
            item.classList.remove("hidden");
            localStorage.removeItem("selected-nav-filter");
          }
        });
        if (filter.checked) {
          this.dispatchEvent(
            new CustomEvent("filter::selected", {
              detail: {
                filterValue: localStorage.getItem("selected-nav-filter"),
              },
            })
          );
        }
      });
    });

    this.savedFilterValue = localStorage.getItem("selected-nav-filter");
    if (this.savedFilterValue) {
      this.filters.forEach((filter) => {
        if (filter.value === this.savedFilterValue) {
          filter.checked = true;
          filter.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });
    }
  }

  reodred() {
    let order = this.dataset.order?.split(",") || null;
    if (!order) {
      order = Array.from(this.filters)
        .find((filter) => filter.checked === true)
        ?.dataset.titlesOrder?.split(",");
    }
    const megaMenuSections = Array.from(
      this.querySelectorAll(".mega-menu__item")
    );
    const sectionsContainer = this.querySelector(".mega-menu__items");
    // sort by the position in the `order` array
    megaMenuSections.sort((a, b) => {
      const titleA = a.dataset.title;
      const titleB = b.dataset.title;
      const idxA = order.indexOf(titleA);
      const idxB = order.indexOf(titleB);
      // if either title isn’t found, push it to the end
      if (idxA === -1) return 1;
      if (idxB === -1) return -1;
      return idxA - idxB;
    });

    sectionsContainer.innerHTML = "";
    megaMenuSections.forEach((section) => {
      sectionsContainer.appendChild(section);
    });
  }

  swapUrls() {
    // 1) Find the checked filter
    const selectedFilter = Array.from(this.filters).find((f) => f.checked);
    if (!selectedFilter) return;

    // Assume your filter inputs have e.g. data-filter="Svenska" or .value = title key
    const key = selectedFilter.value;

    // 2) Parse the JSON blob into a flat map { title: url }

    const urlMap = {};
    const section = this.navigationData.navigation.find(
      (el) => el.title === key
    );
    section.children.forEach((child) => {
      urlMap[child.title] = child.url;
      if (child.children) {
        child.children.forEach((grand) => {
          urlMap[grand.title] = grand.url;
        });
      }
    });
    console.log("url map: ", urlMap);

    // 3) Walk your menu items, swapping href where their data-filter list includes `key`
    this.navItems.forEach((item) => {
      const filters = item.dataset.filters.split(",");
      if (filters.includes(key)) {
        const link = item.querySelector("a");
        if (link) link.href = urlMap[link.textContent.trim()];
      }
    });
  }

  addLinksToMenuItems() {
    const items = Array.from(this.querySelectorAll(".mega-menu__item"));
    const filterMains = this.querySelectorAll("[data-titles-order]").forEach(
      (filterMain) => {
        const value = filterMain.querySelector("input").value;
        const titles = filterMain.dataset.titlesOrder;
        const itemsFound = items.filter((item) =>
          titles.includes(item.dataset.title)
        );
        itemsFound.forEach((item) => {
          if (item.dataset.filters) {
            const filters = item.dataset.filters.split(",");
            filters.push(value);
            item.dataset.filters = filters.join(",");
          } else {
            item.dataset.filters = value;
          }
        });
      }
    );
  }

  _combineLinks() {
    const links = Array.from(this.querySelectorAll(".mega-menu__item-link"));
    const map = new Map();

    links.forEach((link) => {
      // normalize both URL and title to lowercase
      const urlKey = link.href.trim().toLowerCase();
      const titleKey = link.textContent.trim().toLowerCase();
      const key = `${urlKey}|${titleKey}`;

      const filter = link.dataset.filters;

      if (map.has(key)) {
        // merge into existing entry
        map.get(key).filters.add(filter);
        link.remove();
      } else {
        // first occurrence of this URL+title
        map.set(key, {
          element: link,
          filters: new Set([filter]),
        });
      }
    });

    // rewrite each surviving element’s data-filters
    map.forEach(({ element, filters }) => {
      element.dataset.filters = Array.from(filters).join(",");
    });
  }
}

customElements.define("mega-menu", MegaMenu);
